// extracted by mini-css-extract-plugin
export var evergreen = "VideoBanner-module--evergreen--9f4cc";
export var pink25 = "VideoBanner-module--pink25--7002d";
export var pink50 = "VideoBanner-module--pink50--fa970";
export var pink75 = "VideoBanner-module--pink75--e12a2";
export var slideDown = "VideoBanner-module--slide-down--4d4cb";
export var slideUp = "VideoBanner-module--slide-up--f5589";
export var videoButton = "VideoBanner-module--video-button--0b99a";
export var videoMessage = "VideoBanner-module--video-message--2460a";
export var videoMessageWrap = "VideoBanner-module--video-message-wrap--0e00c";